const emailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const companyEmailRegex =
  /^(?!.*@(?:gmail|hotmail|outlook|live|yahoo)\.[a-z]{2,})(?:(?:(?:[^<>()[\].,;:\s@"]+(?:\.[^<>()[\].,;:\s@"]+)*)|(?:".+"))@((?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,}))$/i;

export const validateName = (value = '') => value.length > 1 && value.length < 30;
export const validateEmail = (value = '') => emailRegex.test(value);
export const validateCompanyEmail = (value = '') => companyEmailRegex.test(value);
